import queryString from "query-string";

import { ApiAlertItem } from "@/api/alert";
import { AIRPORT_MAP, COUNTRY_SUBD_LIST, REGION_LIST } from "@/constants/airport";

import { LocationEnum } from "../Routes/hooks/useLocationFilter";

export interface TargetData {
  additional_routes: string | number;
  lowest_miles: {
    bank: string;
    currency: string;
    miles: string;
    prev_miles: string;
    program: string;
    tax: string;
    updated_at: string;
  };
  new_routes_object_id: string;
  version: string;
}

export interface IAlertItem extends ApiAlertItem {
  filterData: any;
  targetData: TargetData;
}

export const sortFunction = (a: ApiAlertItem, b: ApiAlertItem) => {
  if (a.expired && !b.expired) return 1;
  if (!a.expired && b.expired) return -1;

  if (a.valid && !b.valid) return -1;
  if (!a.valid && b.valid) return 1;

  if (a.viewed && !b.viewed) return 1;
  if (!a.viewed && b.viewed) return -1;

  if (a.has_update && !b.has_update) return -1;
  if (!a.has_update && b.has_update) return 1;

  return new Date(a.info.departureDate).getTime() - new Date(b.info.departureDate).getTime();
};

export function formatResponse(list: ApiAlertItem[]) {
  const result = [] as any[];
  list.forEach(
    ({
      alert_id,
      expired,
      filters,
      valid,
      infinite_mode,
      info,
      flight_pts,
      has_update,
      viewed,
      summary,
      alert_type = "flight",
      generate_time,
      phone_number,
    }) => {
      let targetData: any = null;
      const addition_routes = 0;

      if (summary) {
        targetData = {
          additional_routes: summary ? summary.total_flights : 0,
          lowest_miles: {
            bank: summary?.card,
            program: summary?.program,
            tax: summary?.least_tax,
            miles: summary?.least_miles,
          },
          version: summary?.update_time,
        };
        targetData = targetData as TargetData;
      }

      const data = {
        alert_id,
        valid,
        info,
        flight_pts,
        infinite_mode,
        targetData,
        has_update,
        expired,
        viewed,
        alert_type,
        generate_time,
        phone_number,
      } as any;

      const filterData = filters ? filters : {};
      if (Object.keys(filterData).length > 0) {
        data.filterData = filterData;

        if (!filterData.banks) {
          data.filterData.banks = [];
        }

        if (!filterData.airline_programs) {
          data.filterData.airline_programs = [];
        }

        if (!filterData.unwanted_airline) {
          data.filterData.unwanted_airline = [];
        }
      }

      // searchStr
      const { arrival, departure, cabins, passengers, departureDate, departureDateSec, children } =
        info || {};
      const { banks } = filterData;
      const searchParams = {
        multiday: departureDate !== departureDateSec,
        departure,
        arrival,
        departDate: departureDate,
        departDateSec: departureDateSec,
        banks: banks?.join(","),
        cabins,
        passenger: passengers,
        children: children,
      };
      data.searchStr = queryString.stringify(searchParams);
      result.push(data);
    }
  );
  return result;
}

export function getAirportNameByCode(item: string) {
  const [iata, type] = item.split("_");

  const res = AIRPORT_MAP[iata]?.city;
  if (res) {
    return `${res}(${iata})`;
  }
  if (type === LocationEnum.AIRPORT) {
    return `${AIRPORT_MAP[iata]?.city}(${iata})`;
  } else if (type === LocationEnum.REGION) {
    return `${REGION_LIST.find((item) => item.code === iata)?.name}(${iata})`;
  } else if (type === LocationEnum.CITY) {
    return `${COUNTRY_SUBD_LIST.find((item) => item.code === iata)?.name}(${iata})`;
  } else if (type === LocationEnum.COUNTRY) {
    return `${COUNTRY_SUBD_LIST.find((item) => item.code === iata)?.name}(${iata})`;
  } else {
    return `${AIRPORT_MAP[iata]?.city}(${iata})`;
  }
}
